import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSecondarySidebar } from '../../contexts/SecondarySidebarContext';

const HandleQuickCreateWithChildren = ({
    title,
    FormComponent,
    createAction,
    settingsKey,
    formDataKey,
    moduleName,
    setFormData,
    setSettingsAction,
    parent = null,
    parentKey = null,
    resetKey = null
}) => {
    const dispatch = useDispatch();
    const { toggleSecondarySidebar, closeSecondarySidebar } = useSecondarySidebar();
    const { settings } = useSelector(state => state[moduleName]);

    const handleCreate = useCallback(() => {
        toggleSecondarySidebar({
            className: `right-sidebar-md`,
            title,
            content: (
                <FormComponent
                    initialData={parent ? { initialType: 'create', category: parent } : null}
                    onSave={async (data) => {
                        try {
                            const response = await dispatch(createAction(data));
                            
                            if (response && settings) {
                                let updatedItems;
                                
                                if (parent) {
                                    // For subcategories, update the parent's children array
                                    updatedItems = settings[settingsKey].map(item => {
                                        if (item.id === parent?.id) {
                                            return {
                                                ...item,
                                                children: [
                                                    ...(item.children || []),
                                                    {
                                                        id: response.id,
                                                        label: response.label
                                                    }
                                                ]
                                            };
                                        }
                                        return item;
                                    });
                                } else {
                                    // For categories, add to the main array
                                    updatedItems = [
                                        ...(settings[settingsKey] || []),
                                        {
                                            id: response.id,
                                            label: response.label,
                                            children: []
                                        }
                                    ];
                                }
                                
                                dispatch(setSettingsAction({
                                    ...settings,
                                    [settingsKey]: updatedItems
                                }));

                                // Set the newly created item in the form
                                setFormData(prev => ({
                                    ...prev,
                                    [formDataKey]: {
                                        id: response.id,
                                        label: response.label
                                    },
                                    ...(resetKey ? { [resetKey]: null } : {})
                                }));

                                // If this is a subcategory, also update the parent reference
                                if (parentKey) {
                                    setFormData(prev => ({
                                        ...prev,
                                        [parentKey]: {
                                            ...prev[parentKey],
                                            children: [
                                                ...(prev[parentKey]?.children || []),
                                                {
                                                    id: response.id,
                                                    label: response.label
                                                }
                                            ]
                                        }
                                    }));
                                }
                            }
                            
                            return response;
                        } catch (error) {
                            console.error(`Error creating ${title.toLowerCase()}:`, error);
                            throw error;
                        }
                    }}
                    onClose={closeSecondarySidebar}
                />
            ),
        });
    }, [toggleSecondarySidebar, closeSecondarySidebar, dispatch, settings, title, FormComponent, createAction, settingsKey, formDataKey, setFormData, setSettingsAction, parent, parentKey, resetKey]);

    return {
        handleCreate,
        showAddButton: !!parent?.id // Return an object with both the handler and the showAddButton flag
    };
};

export default HandleQuickCreateWithChildren; 